/**
 * How a repeating row says which weekdays it covers.
 *
 * The same shape the `schedule` table has stored for years — a versioned weekday set, or null for a row
 * that covers only its own start date. Availability repeats for the same reasons a schedule does, so it
 * repeats the same way rather than inventing a second vocabulary for it.
 */

export enum RecurrencePatternVersion {
  V1 = 'v1',
}

export interface RecurrencePattern {
  readonly version: RecurrencePatternVersion;
  readonly weekdays: readonly number[];
}

/** A weekday set as a pattern; null when there is nothing to repeat. */
export const toRecurrencePattern = (weekdays: readonly number[]): RecurrencePattern | null =>
  weekdays.length
    ? { version: RecurrencePatternVersion.V1, weekdays: [...weekdays].sort((left, right) => left - right) }
    : null;
